import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, LinearProgress, Stack, Tooltip, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { useGetAllWorkPlans } from "@api/workplanService";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
                </LinkComponent>

                {/* {row.owner && (<Typography fontSize="sm"><Typography fontWeight={'bold'}>Owner</Typography> <LinkComponent to={`/contacts/${row.owner.id}`} relative={true} object={row.owner}>{row.owner.name}</LinkComponent></Typography>)} */}

                {row.contacts.length > 0 && (
                    <Typography fontSize="sm">
                        {/* <Typography fontWeight={'bold'}>Event Chair</Typography> */}
                        {/* {` `} */}
                        <LinkComponent to={`/contacts/${row.contacts[0].id}`} object={row.contacts[0]}>
                            <Typography fontSize="sm">{row.contacts[0].name}</Typography>
                        </LinkComponent>
                    </Typography>
                )}
            </>)
        }
    },
    {
        id: 'tasks',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Tasks',
        cell: (row) => {
            const progress = row.number_tasks ? (((row.number_tasks - row.number_incomplete_tasks) / row.number_tasks) * 100) : 0;
            return (
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={2}
                >
                <Box sx={{flex: '0 1 25%', display: 'flex', justifyContent: 'flex-end'}}>
                        <LinearProgress determinate value={progress} sx={{backgroundColor: 'var(--joy-palette-background-backdrop)'}} />
                    </Box>
                    <Box sx={{flex: 'auto', whiteSpace: 'nowrap'}}>
                        <Tooltip title={'Completed Tasks'}>
                            <Box sx={{display: 'inline'}}>{row.number_tasks - row.number_incomplete_tasks}</Box>
                        </Tooltip>
                        {' of '}
                        <Tooltip title={'Total Tasks'}>
                            <Box sx={{display: 'inline'}}>{row.number_tasks}</Box>
                        </Tooltip>
                    </Box>

                </Stack>
            )
        }
    },
];

export default function WorkPlanListWidget(props) {
    return (
        <ListWidget
            query={useGetAllWorkPlans}
            columns={columns}
            {...props}
        />
    );
}
